<template>
<!--
    @Example
    import 후 el-table의 scoped 내에서 다음과 같이 사용한다.
    <template slot-scope="scope" slot="eventlevel-slot">
      <w-eventlevel-cell :eventlevel-id="scope.row.voEventlevel.eventlevelId"/>
    </template>

    3가지 스타일 제공
    1) type="round" (default) - mini 스타일 제공 (mini 속성 true)
    - round 스타일의 경우 width: 80 설정.
    2) type="background"
    3) type="circle" - mini 스타일 제공 (mini 속성 true)
-->
<div class="eventlevel-cell">
  <!-- BACKGROUND STYLE -->
  <div v-if="eventlevelStyle.BACKGROUND === type" class="background-cell" :style="{color: eventlevel.colorBg, background: convertHex2Rgba(eventlevel.colorBg, 5)}">
    <span v-if="$slots.content === undefined">{{ eventlevel.name }}</span>
    <slot v-else name="content" />
  </div>
  <!-- CIRCLE STYLE -->
  <div v-else-if="eventlevelStyle.CIRCLE === type">
    <span :class="mini === true ? ['event-circle','mini'] : 'event-circle'" :style="{ background: eventlevel.colorBg}"></span>
    <span v-if="$slots.content === undefined">{{ eventlevel.name }}</span>
    <slot v-else name="content" />
  </div>
  <!-- ROUND STYLE (default) -->
  <div v-else :class="mini === true ? ['round-cell','mini'] : 'round-cell'" :style="{ color: eventlevel.colorText, background: eventlevel.colorBg }">
    <span v-if="$slots.content === undefined">{{ eventlevel.name }}</span>
    <slot v-else name="content" />
  </div>
</div>
</template>

<script>
import { isEmpty, convertHex2Rgba } from '@/utils/basic';

export default {
  name: 'WEventlevelCell',
  props: {
    /**
     * 표현할 이벤트 등급 아이디
     * @type {String}
     */
    eventlevelId: {
      type: String,
    },
    type: {
      type: String,
      default: 'default',
    },
    mini: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      eventlevelStyle: {
        BACKGROUND: 'background',
        CIRCLE: 'circle',
        ROUND: 'round',
      },
    };
  },
  computed: {
    /**
     * 이벤트 등급별 정보 객체 (from common store's getters)
     * @author Ju
     * @return {Object} 이벤트 등급별 정보 객체
     */
    eventlevelInfo() {
      return this.$store.getters.eventlevelInfoWithNM;
    },
    /**
     * eventlevelId에 해당하는 이벤트 등급 객체를 반환. { name: '이벤트등급명', color: '이벤트 등급 색상(배경)'}
     * @author Ju
     * @return {Object} 이벤트 등급 객체
     */
    eventlevel() {
      if (!isEmpty(this.eventlevelInfo) && !isEmpty(this.eventlevelInfo[this.eventlevelId])) {
        const eventlevel = this.eventlevelInfo[this.eventlevelId];
        return {
          name: eventlevel.eventlevelName,
          colorBg: eventlevel.eventlevelColorBg,
          colorText: eventlevel.eventlevelColorText,
        };
      }
      return {
        name: this.eventlevelId,
        colorBg: '#fff',
        colorText: '#000',
      };
    },
  },
  methods: {
    /**
     * 16진수 색상 코드(Hex)를 전달 받은 투명도에 따라 rgba 값으로 변환한다.
     *
     * @author Ju
     * @param  {String} hex     16진수 색상 코드 (hex)
     * @param  {Number} opacity 투명도 (백분율 0~100)
     * @return {String}         rgba 값
     */
    convertHex2Rgba(hex, opacity) {
      return convertHex2Rgba(hex, opacity);
    },
  },
};
</script>

<style lang="scss">
.eventlevel-cell {
  .background-cell {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    border-left: 4px solid;
    padding-left: 5px;
    display: flex;
    align-items: center;
  }

  .round-cell {
    border-radius: 11px;
    padding: 0.2em 0.05em;
    width: 55px;
    display: block;
    text-align: center;
    margin: 0 auto;
    letter-spacing: 0.5px;
    font-size: 12px;

    &.mini {
      // border-radius: 5px;
      padding: 0.16em 0.05em;
      width: 52px;
      font-size: 11px;
      // line-height: 1.3;
    }
  }

  .event-circle {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 8px;
    vertical-align: baseline;
    margin-right: 3px;

    &.mini {
      width: 7px;
      height: 7px;
      border-radius: 20px;
      margin-right: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/table/EventlevelCell.vue